import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { MapPinIcon, PlusIcon } from "../../../../assets/ui/icons";
import { addressLineOf } from "./paymentDetailsFields";

/* Where the invoice goes — the block above the card form. */
export const BillingAddressBlock = ({
  address,
  userName,
  onChange,
  onAdd,
  className = "",
}) => {
  if (!address) {
    return (
      <div
        className={cn(
          "flex flex-wrap items-center justify-between gap-3 rounded-[13px]",
          "border-[1.5px] border-dashed border-[var(--dropzone-border)]",
          "bg-[var(--field-inset)] px-4 py-4",
          className
        )}
      >
        <div className="min-w-0">
          <p className="m-0 text-[13.5px] font-bold text-[var(--ink)] font-sans">
            Add a billing address to continue
          </p>
          <p className="m-0 mt-0.5 text-[12px] text-[var(--muted)] font-sans">
            We need it for the invoice before the card form can open.
          </p>
        </div>
        <Button variant="coralSolid" size="sm" className="gap-2" onClick={onAdd}>
          <PlusIcon size={13} />
          Add address
        </Button>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex flex-wrap items-start justify-between gap-3 rounded-[13px]",
        "bg-[var(--navy)] px-4 py-4",
        className
      )}
    >
      <div className="flex min-w-0 gap-3">
        <span
          aria-hidden="true"
          className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white"
        >
          <MapPinIcon size={14} />
        </span>
        <div className="min-w-0">
          <p className="m-0 text-[10.5px] font-bold uppercase tracking-[.11em] text-white/50 font-sans">
            Billing address
          </p>
          <p className="m-0 mt-1 text-[13.5px] font-bold text-white font-sans">
            {address?.companyName || userName}
          </p>
          {address?.mobile && (
            <p className="m-0 mt-0.5 text-[12.5px] text-white/70 font-sans">
              {address.mobile}
            </p>
          )}
          <p className="m-0 mt-0.5 text-[12.5px] leading-[1.5] text-white/70 font-sans">
            {addressLineOf(address)}
          </p>
        </div>
      </div>

      <Button variant="onDark" size="sm" onClick={onChange}>
        Change address
      </Button>
    </div>
  );
};

export default BillingAddressBlock;
